import { DELAWARE_STATE_UUID } from "constants/entity";

type StateOption = { value: string; label: string };

export const pinDelawareFirst = (options: StateOption[]): StateOption[] => {
  const delaware = options.find(
    (option) => option.value === DELAWARE_STATE_UUID
  );
  if (!delaware) return options;

  const rest = options.filter((option) => option.value !== DELAWARE_STATE_UUID);
  return [delaware, ...rest];
};
